module.exports = __webpack_public_path__ + "static/media/ezgif.com-optimize (3).10996131.gif";